/* ==========================================================================
   PBL product page: buy box wrapper - Sep 2026
   Loaded from snippets/meta-tags.liquid on product pages only.

   Kevin: the thin spacer lines were not separating the info column well, so
   the "choose your order" blocks (SA Variants size swatches, the Awesome
   Quantity 1/2/3 PACK tiers, and the ADD TO CART form) are wrapped in one
   soft-blue card (.pbl-buybox, styled in assets/pbl-pdp.css). Nothing is
   cloned or re-rendered: the theme/app blocks are moved as-is into the
   wrapper, so their scripts keep working (verified: SA Variants swatch click
   still navigates to the sibling listing, the form still submits).

   Retire: delete this file and its script tag in snippets/meta-tags.liquid.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__pblPdp) return;
  window.__pblPdp = true;

  function wrap() {
    var outer = document.querySelector('.product__info-container.block > .product__info-container');
    if (!outer || outer.querySelector('.pbl-buybox')) return;
    var kids = Array.prototype.slice.call(outer.children);
    var start = -1, end = -1;
    kids.forEach(function (k, i) {
      if (start === -1 && k.querySelector('variant-king-combined-listing')) start = i;
      if (k.querySelector('.product-form')) end = i;
    });
    // no size swatches (single-size product): start the box at the first Awesome Quantity block instead
    if (start === -1) {
      kids.forEach(function (k, i) {
        if (start === -1 && k.querySelector('[class*="awesome"],[id*="awesome"]') && k.getBoundingClientRect().height > 0) start = i;
      });
    }
    if (start === -1 || end === -1 || end < start) return;
    var box = document.createElement('div');
    box.className = 'pbl-buybox';
    outer.insertBefore(box, kids[start]);
    for (var i = start; i <= end; i++) box.appendChild(kids[i]);
  }

  function init() {
    wrap();
    // app blocks (SA Variants, Awesome Quantity) can render after load; re-check briefly
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      wrap();
      if (document.querySelector('.pbl-buybox') || tries >= 20) clearInterval(t);
    }, 250);
    document.addEventListener('shopify:section:load', wrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
